//@ts-ignore
import { getActualThemeId } from '@yandex-int/k-common/utils/get-actual-theme-id';
import get from 'lodash/get';
import { Link, Tabs, Text } from 'platform-components';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { matchPath } from 'react-router-dom';
import ym from 'react-yandex-metrika';

import { isPrimarySchool } from 'common.components/user/utils';

import { ReduxTeacherStore } from '../../../typings';
import { useCurrentGrade } from '../../../utils/use-current-grade';
import { CONTENT_TYPES } from '../../library.common/typings';
import { getThemeDetails } from '../../library.store/selectors';

type StoreProps = ReturnType<typeof mapStateToProps>;

interface OwnProps extends WithRouterPathProps {
    shouldHideTabs: boolean;
}

interface Props extends StoreProps, OwnProps {}

interface Context {
    staticUrls: {
        labLibrarySubjectThemeStacks: string;
        labLibrarySubjectThemeLessons: string;
        deepLabStacks: string;
        deepLabThemeLessons: string;
    };
}

// eslint-disable-next-line complexity
export const ThemePageTabs = (props: Props, context: Context) => {
    const {
        themeDetails,
        getRouterPath,
        shouldHideTabs,
        match: {
            path,
            params: { classId, subject, themeId },
        },
        location: { search },
    } = props;
    const { staticUrls } = context;
    const grade = useCurrentGrade();

    const handleClickTab = useCallback(() => {
        ym('reachGoal', 'teacher_lesson_creation_intopic_tabsuse', {
            subject,
            themeId,
        });
    }, [subject, themeId]);

    const isStacksPath = [staticUrls.labLibrarySubjectThemeStacks, staticUrls.deepLabStacks].some((url) =>
        matchPath(path, { path: url, exact: true })
    );
    const currentContent = isStacksPath ? CONTENT_TYPES.STACKS : CONTENT_TYPES.PREP_LESSONS;

    if (shouldHideTabs) {
        return null;
    }

    const lessonCount = get(themeDetails, 'lessons_count', 0);
    const stacksCount = get(themeDetails, 'stacks_count', 0);
    const shouldShowStacksTab = stacksCount > 0;
    const lessonsAreNotEmpty = lessonCount > 0;
    // показываем таб ГЗ, если они есть и в 5ом классе если нет стопок
    const shouldShowPrepLessonsTab = lessonsAreNotEmpty && (isPrimarySchool(grade) || stacksCount === 0);
    const stacksPath = classId ? staticUrls.labLibrarySubjectThemeStacks : staticUrls.deepLabStacks;
    const lessonsPath = classId ? staticUrls.labLibrarySubjectThemeLessons : staticUrls.deepLabThemeLessons;

    return (
        <div className="theme-page__tabs">
            <Tabs>
                {shouldShowStacksTab ? (
                    <Link
                        isRouter
                        mix="qa_theme-tabs-stacks"
                        theme={Link.THEME.INHERIT}
                        to={`${getRouterPath(stacksPath)}${search}`}
                    >
                        <Tabs.Tab
                            counter={stacksCount}
                            id={CONTENT_TYPES.STACKS}
                            onTabSelect={handleClickTab}
                            selected={currentContent === CONTENT_TYPES.STACKS}
                        >
                            <Text id="library.tabs.stacks" />
                        </Tabs.Tab>
                    </Link>
                ) : null}
                {shouldShowPrepLessonsTab ? (
                    <Link
                        isRouter
                        mix="qa_theme-tabs-lessons"
                        theme={Link.THEME.INHERIT}
                        to={`${getRouterPath(lessonsPath)}${search}`}
                    >
                        <Tabs.Tab
                            counter={lessonCount}
                            id={CONTENT_TYPES.PREP_LESSONS}
                            onTabSelect={handleClickTab}
                            selected={currentContent === CONTENT_TYPES.PREP_LESSONS}
                        >
                            <Text id="library.tabs.prepLessons" />
                        </Tabs.Tab>
                    </Link>
                ) : null}
            </Tabs>
        </div>
    );
};

const mapStateToProps = (
    storeState: ReduxTeacherStore,
    {
        match: {
            params: { themeId: thId },
        },
    }: OwnProps
) => {
    let themeId = Number(thId);
    themeId = getActualThemeId(themeId);

    return {
        themeDetails: getThemeDetails(storeState, { themeId }),
    };
};

ThemePageTabs.contextTypes = {
    staticUrls: PropTypes.object.isRequired,
};

export default withRouterPath(connect(mapStateToProps)(ThemePageTabs));
